export default {
  name: "LinkTile",
  props: {
    grid: {
      type: [Array, Object],
      required: true
    },
    gameState: {
      type: Object,
      default: () => ({})
    },
    iconSet: {
      type: Array,
      required: true
    }
  },
  computed: {
    flatGrid() {
      return this.grid.flatMap((row, y) => row.map((tile, x) => ({
        ...tile,
        y,
        x
      })));
    }
  },
  data() {
    return {
      lineCoords: '',
      clearTimer: null
    };
  },
  watch: {
    lastConnection() {
      this.updateLines();
    },
    grid() {
      this.updateLines();
    }
  },
  methods: {
    updateLines() {
      if (!this.gameState.lastConnection || !this.$refs.containerRef) {
        this.lineCoords = "";
        return;
      }
      const rect = this.$refs.containerRef.getBoundingClientRect();
      const cellWidth = rect.width / this.grid[0].length;
      const cellHeight = rect.height / this.grid.length;
      const points = this.gameState.lastConnection.map(p => ({
        x: (p.x + 0.5) * cellWidth,
        y: (p.y + 0.5) * cellHeight
      }));
      let path = `M ${points[0].x} ${points[0].y}`;
      for (let i = 1; i < points.length; i++) {
        path += ` L ${points[i].x} ${points[i].y}`;
      }
      this.lineCoords = path;

      // 清理旧的 timeout
      if (this.clearTimer) clearTimeout(this.clearTimer);

      // 500ms 后清除
      this.clearTimer = setTimeout(() => {
        this.lineCoords = "";
      }, 500);
    },
    handleClick(tile) {
      this.$emit("onTileClick", tile);
    }
  },
  mounted() {
    this.updateLines();
  }
};